import React from "react";
import { Container, Segment } from "../../../app/_shims/semantic-ui-react";
import InText from "../../../app/_shims/InText";
import {
  GridColumnShim,
  GridRowShim,
  GridShim,
} from "../../../components/shims";

function getMidnightDate() {
  const now = new Date();
  now.setHours(0, 0, 0, 0); // Set time to midnight
  const options = { year: "numeric", month: "long", day: "numeric" };
  const dateStr = now.toLocaleDateString("en-US", options);
  return `${dateStr} 12:00 AM`;
}

function LandingFooter() {
  return (
    <>
      <div className="footer_desclaimer">
        <p className="top_desclaimer">
          All information provided on this website including but not limited to
          - school ratings, safety, amenities, user opinions, and property data
          - is for general informational purposes only. We do not guarantee its
          reliability, accuracy, or completeness. Users should independently
          verify information and consult appropriate professionals as needed. By
          using this website, you agree Houseberry is not responsible for
          actions, decisions, or consequences arising from reliance on the
          information provided
        </p>
        <p className="mls_number">houseberry.com - CA DRE# 01847391</p>
        {/* <p className="listing_sources">
          <span>Listing Sources:</span>
        </p>
        <div className="footer_middle_sec">
          MLSListings Inc{" "}
          <img
            src="/static/images/MLSListings_Logo.png"
            className="mls_logo"
          />{" "}
          San Francisco MLS bridgeMLS/CCAR/Bay East AOR{" "} */}

        {/* </div> */}
        <p className="bottom_desclaimer">
          <span>
            <img
              src="/static/images/bay_east_logo.jpg"
              className="bayeast_logo"
            />{" "}
          </span>
          Bay East ©2025. CCAR ©2025. bridgeMLS ©2025. Information Deemed
          Reliable But Not Guaranteed. This information is being provided by the
          Bay East MLS, or CCAR MLS, or bridgeMLS. The listings presented here
          may or may not be listed by the Broker/Agent operating this website.
          This information is intended for the personal use of consumers and may
          not be used for any purpose other than to identify prospective
          properties consumers may be interested in purchasing. Data last
          updated at {getMidnightDate()}
        </p>
      </div>
      <Segment vertical className="footer">
        <Container textAlign="center" className="footer-container">
          <GridShim columns={6} divided>
            <GridRowShim className="footer_items">
              <GridColumnShim className="first-item">
                <a
                  href="/Welcome"
                  title="Welcome"
                  style={{ textAlign: "center" }}
                >
                  <InText name="Welcome" />
                </a>
              </GridColumnShim>
              <GridColumnShim>
                <a href="/blog" title="Blog" style={{ textAlign: "center" }}>
                  <InText name="Blog" />
                </a>
              </GridColumnShim>
              <GridColumnShim>
                <a
                  href="/Aboutus"
                  title="About Us"
                  style={{ textAlign: "center" }}
                >
                  <InText name="About Us" />
                </a>
              </GridColumnShim>
              <GridColumnShim>
                <a
                  href="/ContactUs"
                  title="Contact Us"
                  style={{ textAlign: "center" }}
                >
                  <InText name="Contact Us" />
                </a>
              </GridColumnShim>
              <GridColumnShim>
                <a
                  href="/agentlanding"
                  title="Agents"
                  style={{ textAlign: "center" }}
                >
                  <InText name="Agents" />
                </a>
              </GridColumnShim>
              <GridColumnShim>
                <a
                  href="/Policies"
                  title="Policies"
                  style={{ textAlign: "center" }}
                >
                  <InText name="Policies" />
                </a>
              </GridColumnShim>
              {/* <Grid.Column>
                <a href="/Terms">
                  <InText name="Terms of Use" />
                </a>
              </Grid.Column> */}
              {/* <Grid.Column className="last-item">
                <a href="/Fairhousing">
                  <InText name="Fair Housing" />
                </a>
              </Grid.Column> */}
            </GridRowShim>
          </GridShim>
        </Container>
      </Segment>
    </>
  );
}

export default LandingFooter;
